"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnswersStoreProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const stores_1 = require("../stores/index.js");
const AnswersStoreProvider = ({ children }) => {
    const storeRef = (0, react_1.useRef)(undefined);
    if (!storeRef.current) {
        storeRef.current = (0, stores_1.createAnswersStore)();
    }
    return (0, jsx_runtime_1.jsx)(stores_1.AnswersStoreContext.Provider, { value: storeRef.current, children: children });
};
exports.AnswersStoreProvider = AnswersStoreProvider;
